import React from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import style from 'components/moreDetails/MoreDetailsStyle';

function CommonModal(props) {
  const handleClose = () => {
    props?.handleClose();
  };
  return (
    <div>
      <Modal
        open={props?.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modelMain"
      >
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="modelCloseIcon"
          >
            <CloseIcon />
          </IconButton>
          {props.selectedImage ? (
            <img
              src={props.selectedImage}
              alt="driving"
              className="height500 mt15"
            />
          ) : (
            props.children
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default CommonModal;
